import script from "./RequirementPart.vue?vue&type=script&setup=true&lang=js"
export * from "./RequirementPart.vue?vue&type=script&setup=true&lang=js"

import "./RequirementPart.vue?vue&type=style&index=0&id=76b570ea&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-76b570ea"]])

export default __exports__